/**
 * Trims leading/trailing whitespace from an href/url string.
 *
 * CMS editors occasionally type a leading space (e.g. ` https://accentro.de/...`)
 * into free-text url fields. Such a value is a malformed href and makes
 * next/link throw `Invalid href`. This normalizes the value before it reaches
 * the router. Whitespace-only or empty values fall back to `fallback`.
 */
export const normalizeHref = ({
  href,
  fallback = '#',
}: {
  href?: string | null
  fallback?: string
}): string => {
  const trimmed = href?.trim()
  return trimmed ? trimmed : fallback
}
